import { api } from '@/lib/api'

/**
 * @typedef {{
 *   enabled: boolean,
 *   points_balance: number,
 *   min_redeem_points: number,
 *   redeem_rate: number,
 *   earn_rate: number,
 *   max_redeem_discount: string,
 *   can_redeem: boolean,
 * }} CustomerLoyaltySummary
 */

/**
 * @param {number} customerId
 * @returns {Promise<CustomerLoyaltySummary>}
 */
export async function fetchCustomerLoyalty(customerId) {
  const { data } = await api.get(`/customers/${customerId}/loyalty`)
  return data.data.loyalty
}
